module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VGF02-3285f003c2cff80d12663b3d8f73fee3.png";